import { BoksPacket } from '@/protocol/_BoksPacketBase';
import { BoksOpcode, EMPTY_BUFFER } from '@/protocol/constants';

/**
 * Command to get the number of active codes.
 */
export class CountCodesPacket extends BoksPacket {
  static readonly opcode = BoksOpcode.COUNT_CODES;
  get opcode() {
    return CountCodesPacket.opcode;
  }
  static fromPayload(payload: Uint8Array): CountCodesPacket {
    return new CountCodesPacket(payload);
  }
  toPayload() {
    return EMPTY_BUFFER;
  }
}
